		 					
				import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class PropertyItemSpecialItemService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('PropertyItemSpecialItem');
	}
	
	loadAll(date: Date) : Observable<TooBig4Car.Logic.PropertyItemSpecialItem[]> {
		return this.myBaseService.loadAll(this.url + '?date=' + this.myBaseService.getDateStr(date));
	}
	save(tempItem: TooBig4Car.Logic.PropertyItemSpecialItem) : Observable<TooBig4Car.Logic.PropertyItemSpecialItem> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<TooBig4Car.Logic.PropertyItemSpecialItem> {
		return this.myBaseService.getEdit(id, this.url);
	}
	
}
				
